import { render } from "./ModelViewerWrapper.vue?vue&type=template&id=d6f4d87a&scoped=true"
import script from "./ModelViewerWrapper.vue?vue&type=script&lang=js"
export * from "./ModelViewerWrapper.vue?vue&type=script&lang=js"

import "./ModelViewerWrapper.vue?vue&type=style&index=0&id=d6f4d87a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6f4d87a"]])

export default __exports__